
export default {
    // 接口url
    getProductBase:"pms/product/pub/getProductBase", // 基本盘列表
    getPubMarketingTagVo:"pms/product/pub/getPubMarketingTagVo", // 工具箱列表--分类
    getProductTools:"pms/product/pub/getProductTools",//工具箱列表
    getCurrencyFund:"pms/product/pub/getCurrencyFund",//货币基金--产品列表
    getCurrencyFundTitle:"pms/product/pub/getCurrencyFundTitle",//货币基金--推荐位
    saveOptionalProduct:"pms/product/pub/saveOptionalProduct",//添加/取消自选
    getFixedInputPersonRecord:"pms/product/pub/getFixedInputPersonRecord",//获取定投历史
    getFixedInputProductList:"pms/product/pub/getFixedInputProductList",//获取定投产品列表
    getNewFundManagerRecommendList:"pms/product/pub/getNewFundManagerRecommendList",//新发基金-推荐位
    getNewFundProductList:"pms/product/pub/getNewFundProductList",//新发基金--产品列表
    getHomePageProductList:"pms/product/pub/getHomePageProductList",//公募首页进取投资/稳健投资产品列表
    getAppScrollMessageResList:"pms/product/pub/getAppScrollMessageResList",//公募首页滚动消息列表
    getFixedInvestmentRecommend:"pms/fixed/investment/getFixedInvestmentRecommend",//省心定投--精选推荐
    getAlLFixedInvestmentTag:"pms/fixed/investment/getAlLFixedInvestmentTag",//省心定投--分类标签
    getFixedInvestmentProduct:"pms/fixed/investment/getFixedInvestmentProduct",//省心定投--产品列表


    getFilterProductList:"pms/product/pub/filter/getFilterProductList",//基金筛选
    getFundCompanyList:"pms/product/pub/filter/getFundCompanyList",//基金筛选-基金公司列表
    getFundManagerList:"pms/product/pub/filter/getFundManagerList",//基金筛选-基金经理列表
    getFundThemeList:"pms/product/pub/filter/getFundThemeList",//基金筛选-基金主题列表
    addPubFilterRecord:"pms/product/pub/filter/addPubFilterRecord",//新增基金筛选记录
    getPubFilterRecord:"pms/product/pub/filter/getPubFilterRecord",//查询基金筛选记录
    getFilterProductFundTypeList:"pms/product/pub/filter/getFilterProductFundTypeList",//基金分类
    addCondition:"pms/product/pub/filter/addCondition",//保存条件分类
    conditionList:"pms/product/pub/filter/conditionList",//条件名称列表
    editCondition:"pms/product/pub/filter/editCondition",//修改条件名称
    delCondition:"pms/product/pub/filter/delCondition",//删除条件
    topCondition:"pms/product/pub/filter/topCondition",//置顶条件
    conditionDetail: "pms/product/pub/filter/conditionDetail",//查看条件详情
    filterAddShareRecord: "pms/product/pub/filter/addShareRecord",//生成分享记录
    shareProductList:"pms/product/pub/filter/shareProductList",//分享列表


    getStockBondInterestMarginList:"pms/product/pub/getStockBondInterestMargin",//风向标下方 双折线图
    getWindVaneTitleList:"pms/product/pub/getWindVaneTitle",//风向标上方 头部信息
    getWindVaneList:"pms/product/pub/getWindVane",//风向标 柱状图
    getThermometer:"pms/product/pub/getThermometer",//温度计下方 列表

    getPubProductListAc:"pms/product/pub/getPubProductList",//公募榜单

    getTodayPubFinancialBreakfast:"pms/product/pub/getTodayPubFinancialBreakfast",//财经早餐-首页
    getPubFinancialBreakfastDetail:"pms/product/pub/getPubFinancialBreakfastDetail",//财经早餐-App详情+分享详情
    getPubFinancialBreakfastPreview:"pms/product/pub/getPubFinancialBreakfastPreview",//财经早餐-预览(中台预览)

    //对比基金
    productCompareHotFundList:"pms/product/pub/productCompareHotFundList" ,//热门基金
    productCompareOwnOptionalList:"pms/product/pub/productCompareOwnOptionalList" ,//我的自选
    productCompareRecentBrowseList:"pms/product/pub/productCompareRecentBrowseList" ,//最近浏览
    productCompareRecordList:"pms/product/pub/productCompareRecordList" ,//对比记录
    productCompareSearchFundList:"pms/product/pub/productCompareSearchFundList" ,//搜索基金
    productCompareChoiceList:"pms/product/pub/productCompareChoiceList",//基金选择
    addProductCompareChoice:"pms/product/pub/addProductCompareChoice", //基金选择新增
    deleteProductCompareChoice:"pms/product/pub/deleteProductCompareChoice", //基金选择删除
    deleteProductCompareRecord:"pms/product/pub/deleteProductCompareRecord",//清除历史对比记录
    addProductCompareRecord:"pms/product/pub/addProductCompareRecord",//新增对比记录
    deleteProductCompareRecentBrowse:"pms/product/pub/deleteProductCompareRecentBrowse", //清除浏览记录
    getPubRobustFinancialManage:"pms/product/pub/getPubRobustFinancialManage",//稳健理财
    getPubRobustFinancialManageRecommend: "pms/product/pub/getPubRobustFinancialManageRecommend", // 稳健理财推荐位
    addPubMessageDisplay: "pms/product/pub/addPubMessageDisplay",//增加关闭消息记录
    chasingRevenue: "pms/product/pub/chasingRevenue",//追求收益

    // +++++++++++++++++++基金PK++++++++++++++++++
    fundPk:"pms/product/pub/getFundComparisionResult", // 基金PK
    fundAnnualPerformance:"pms/product/pub/getFundComparisionResultYearYied", // 年度业绩
    fundManager:"pms/product/pub/getFundComparisionResultManager", // 基金经理
    removeFundPK:"pms/product/pub/delProductAddProductCompareRecord",//删除
    // +++++++++++++++++++基金PK++++++++++++++++++

    getProductBaseDraft:"pms/product/pub/getProductBaseDraft",//基本盘预览
    getPubMarketingTagVoDraft:"pms/product/pub/getPubMarketingTagVoDraft",//工具箱列表--分类预览
    getProductToolsDraft:"pms/product/pub/getProductToolsDraft",//工具箱列表预览
    getPubMarketingTagVoTemp:"pms/product/pub/getPubMarketingTagVoTemp",//工具箱列表预览
    getNewProductDraftList:"pms/product/pub/getNewProductDraftList",//新发基金预览
    getProductRecommend:"pms/product/pub/getProductRecommend",//货币基金预览

    getFundComparisionResultGraphics: "pms/product/pub/getFundComparisionResultGraphics", // 公募首页改版-基金对比走势图
    getFundComparisionResult: "pms/product/pub/getFundComparisionResult", // 公募首页改版-基金对比

    addPubProductDetailRecord:"pms/product/pub/addPubProductDetailRecord",//产品浏览记录
    addOwnRecord:"pms/product/pub/addOwnRecord",//自选埋点
    loginInfoBuriedPoint:"pms/product/pub/loginInfoBuriedPoint",//新版公募相关页面埋点
    // 我的自选
    privatePlacementOptionalList:"pms/product/private/privatePlacementOptionalList",//私募我的自选
    findOwnOptionalList:"pms/product/pub/findOwnOptionalList",//公募我的自选
    themeFundList:"pms/product/pub/theme/list",//主题选基列表
    optionalList:"pms/product/pub/fund/index/optional/list",//指数选基
    operatingBypmsOptional:"pms/product/private/operatingBypmsOptional",//添加/取消自选
    // loginInfoBuriedPoint: "pms/product/pub/loginInfoBuriedPoint",//新版公募相关页面埋点
    // 主题选基
    getThemeList:"pms/product/pub/theme/list",//主题选基列表
    // 指数选基
    getIndexList:"pms/product/pub/fund/index/list",//指数选基列表
    getIndexTypeList:'pms/product/pub/fund/index/type',//指数类型

    // 股票选基
    getStockIndex: "pms/product/pub/stock/choosing/fund", // 股票选基首页
    getStockResult: "pms/product/pub/stock/choosing/fund/result", // 股票选基结果

    themeSearch:"pms/product/pub/theme/search",//主题搜索
    themeOption:"pms/product/pub/theme/option",//主题添加自选
    themeDetail:"pms/product/pub/theme/detail",//主题详情
    indexDetail:"pms/product/pub/fund/index/detail",//指数详情
    indexSearch:"pms/product/pub/fund/index/search",//指数搜索
    indexOption:"pms/product/pub/add/optional/fund/index",//指数添加自选
    stockSearch:"pms/product/pub/stock/choosing/search",//股票搜索
    recommendTheme: "pms/product/pub/theme/recommend", // 看主题
    recommendStock: "pms/product/pub/stock/choosing/look/stock", // 看股票
    recommendIndex: "pms/product/pub/fund/index/look/index", // 看指数
    productSearch:"pms/product/pub/productSearch",       //产品搜索
    //四期
    getPublicOfferingInterpretation:"pms/product/pub/getPublicOfferingInterpretation",//公募首页改版-公募解读
    getFeaturedThisWeek: "pms/product/pub/getFeaturedThisWeek",//公募首页改版-本周精选
    getLupuObserveTypeList: "pms/product/pub/getLupuObserveTypeList", // 公募首页改版-陆浦观察标签列表
    getLupuObserve: "pms/product/pub/getLupuObserve", // 公募首页改版-陆浦观察列表

    //公募批量买入
    batchBookingList:"pms/product/pub/bundle/booking/list",//批量买入查询列表
    batchCustomerVerification:"tms/pub/bundle/booking/buy/verification/customer",//批量买入客户资质校验
    fundUpperLimit:"tms/pub/bundle/booking/fundUpperLimit",//批量买入基金上线
    batchProductVerification:"tms/pub/bundle/booking/buy/verification",//批量买入校验
    batchBuyAmountFee:"tms/pub/booking/cal/buyAmountFee",//购买申购费用计算
    calcAmountRules:"tms/pub/booking/buy/verification/amount",//规则
    buyPageInitData:"tms/pub/bundle/booking/init/data",//公募批量买入页面信息初始化
    bookingEnabled:"tms/pub/bundle/booking/enabled",//我的自选是否展示批量买入按钮
    pubSharesignature:"pms/product/pub/pubShareSignature",//H5分享获取签名
    addPubShareRecord:"pms/product/pub/addPubShareRecord",//H5分享接口
    shoppingCartList:"pms/product/pub/cart/content/list",//购物车批量买入查询列表
    addShoppingCart:"pms/product/pub/cart/content/add/product",//购物车产品添加到购物车
    optionalAddShoppingCart:"pms/product/pub/cart/content/add/optional/product",//自选产品添加到购物车
    deleteShoppingCart:"pms/product/pub/cart/content/sub/product",//删除购物车产品
    investmentRecommendList:"pms/product/pub/cart/investmentRecommend",//获取投研推荐列表
    isClickedShareBtn:"pms/product/pub/cart/enabled",//分享按钮是否可点击
    shareRecordText:"pms/product/pub/cart/addShareRecord",//生成分享记录
    browseShareRecord:"pms/product/pub/cart/addBrowseRecord",//浏览器分享记录

    shareCartProductList:"pms/product/pub/cart/shareCartProductList",//分享的购物车列表
    sendVerificationCode:"share/sendVerificationCode",//获取验证码
    checkVerificationCode:"share/checkVerificationCode",//验证短信验证码
    getCustomerInfoListByPhoneNo:"cms/customerInfo/getCustomerInfoListByPhoneNo",//查询身份
    addMyOptionProduct:"pms/product/pub/cart/addMyOptionProduct",//一键添加我的自选

    bannerImgList:"pms/product/pub/home/bannerList",//公募首页banner图列表
    districtList:"pms/product/pub/home/districtList",//公募首页金刚区
    columnList:"pms/product/pub/home/columnList",//公募首页栏目列表
    indexList:"pms/product/pub/home/indexList",//看指数预览列表
    performanceList:"pms/product/pub/home/performanceList",//看业绩预览列表
    stockList:"pms/product/pub/home/stockList",//看股票预览列表
    themeList:"pms/product/pub/home/themeList",//看主题预览列表
    steadyList:"pms/product/pub/home/steadyList",//看稳健投资预览列表
    getHomePageRecommendList:"pms/product/pub/getHomePageRecommendList",//首页推荐位

    productMarketingPageDetail: "pms/product/pub/productMarketingPageDetail", // 产品营销单页
    passwordConversionGet:"pms/product/pub/passwordConversionGet", // 通过code口令 获取id
    pubShareFaInfo:"pms/product/pub/pubShareFaInfo", // 获取分享fa信息
    getFundDetails: "pms/product/pub/productList", // 获取基金详情列表
}